export default "__VITE_ASSET__DhnOHfrj__";